<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{'endpoints.key_request.display_dialog.title' | translate}}</h2>
<h3 class="sub-title">{{subTitle}}</h3>

<div mat-dialog-content class="container">
    <div class="wrapper">
        <div class="row">
            <span class="label">{{'endpoints.key_request.display_dialog.key_id' | translate}}:</span>
            <div class="value">{{ this.data.keyId}} </div>
        </div>
        <div class="row">
            <span class="label">{{'endpoints.key_request.display_dialog.key' | translate}}:</span>
            <div class="value">
                {{ this.data.volume_config.key }}
                <span id="copyActivationCodeButton" class="mdi mdi-content-copy clickable icon copy-icon"
                  matTooltip="{{'endpoints.key_request.display_dialog.copy_key_tooltip' | translate}}" matTooltipPosition="right"
                  (click)="onCopyBitlockerKey()"></span>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="button-wrapper" align="end">
    <button mat-raised-button color="primary" (click)="onButtonClick()" type="button">
        <span>{{'H_CLOSE' | translate}}</span>
    </button>
</div>
